import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MeteringPointChargeInformationDto, MeteringPointChargeInformationService } from '@app/api/dmc';
import { FormApiService } from '@app/core/services/form-api.service';
import { InputDirective } from '@shared/components/input/input/input.directive';
import { InputGroupComponent } from '@shared/components/input/input-group/input-group.component';
import { LabelDirective } from '@shared/components/input/label/label.directive';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { InputDateDirective } from '@shared/components/input/date/input-date.directive';
import { HasUnsavedChanges } from '@app/core/guards/unsaved-changes.guard';

@Component({
  selector: 'app-disassociate-charge-information',
  imports: [
    InputDirective,
    InputGroupComponent,
    LabelDirective,
    ReactiveFormsModule,
    TranslatePipe,
    InputDateDirective
  ],
  templateUrl: './disassociate-charge-information.component.html',
  styleUrl: './disassociate-charge-information.component.css'
})
export class DisassociateChargeInformationComponent implements OnInit, HasUnsavedChanges{
  public hasUnsavedChanges(): boolean {
    return this.form.dirty;
  }

  public form: FormGroup = new FormGroup({
    meteringPointIdentification: new FormControl(null, Validators.required),
    validTo: new FormControl(new Date(), Validators.required),
    validFrom: new FormControl(null, Validators.required),
    chargeTypeId: new FormControl(null, Validators.required),
    chargeType: new FormControl(null, Validators.required),
    chargeOccurrences: new FormControl(null, Validators.required),
    chargeInformationOwner: new FormControl(null, Validators.required),
  })
  public identification?: string;
  public chargeInformation?: MeteringPointChargeInformationDto;

  constructor(
    private readonly formApiService: FormApiService,
    private readonly meteringPointChargeInformationService: MeteringPointChargeInformationService,
    private readonly translateService: TranslateService
  ) {
  }
  public ngOnInit(): void {
    if(this.identification)
    {
      this.form.get('meteringPointIdentification')?.setValue(this.identification);
    }
    if(this.chargeInformation)
    {
      this.form.get('chargeTypeId')?.setValue(this.chargeInformation.chargeTypeId);
      this.form.get('chargeType')?.setValue(this.chargeInformation.chargeType);
      this.form.get('chargeOccurrences')?.setValue(this.chargeInformation.chargeOccurrences);
      this.form.get('validFrom')?.setValue(this.chargeInformation.validFrom);
      this.form.get('chargeInformationOwner')?.setValue(this.chargeInformation.chargeInformationOwner);
    }
  }
  getTranslatedChargeType(): string {
    const chargeType = this.form.get('chargeType')?.value;
    if (!chargeType) return '';

    const translationKey = `chargeInformation.chargeTypes.${chargeType.toLowerCase()}`;
    return this.translateService.instant(translationKey);
  }

  public disassociate(): void {
    if(this.form.valid)
    {
      this.form.get('validTo')?.setValue(new Date(this.form.get('validTo')?.value).toISOString().split('T')[0]);
      this.formApiService.submit(
        this.form,
        (data) => this.meteringPointChargeInformationService.meteringPointChargeInformationDisassociatePost(data),
        {
          successMessage: 'meteringpoint.pricing.disassociateChargeInformationSuccesful',
          closeModal: true,
        }
      );
    } else {
      this.form.markAllAsTouched();
    }
  }
}
